<template>
  <div class="project-container d-flex flex-column">
    <router-link :to="link" style="overflow: hidden">
      <b-img class="project-image" :src="require('../assets/'+image)" style="width: 100%; height: auto"></b-img>
    </router-link>
    <div class="d-flex flex-column p-2">
      <router-link :to="link">
        <div class="title">{{ this.title }}</div>
      </router-link>
      <div class="subtitle">{{ this.subtitle }}</div>
      <div class="d-flex pt-2 pb-2">
        <TagList :small="true" :tags="tags"/>
      </div>
    </div>
  </div>
</template>

<script>
import TagList from "@/components/TagList";
export default {
  name: "MainWorksProject",
  components: {TagList},
  props:{
    title:{
      type: String,
      default: "Title"
    },
    subtitle:{
      type: String,
      default: "Subtitle"
    },
    tags:{
      type: Array,
      default: () => ['Tag', 'Tag']
    },
    image:{
      type: String,
      default: "hc3p/HC3P_Carrousel_5.jpg"
    },
    link:{
      type: String,
      default: "/"
    }
  }
}
</script>

<style lang="scss" scoped>

@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

.project-container{
  background-color: white;
  margin: 5px 30px 5px 0px;
  width: 100%;
  box-shadow: 5px 5px 8px 5px rgba(0, 0, 0, 0.5);

  @include media-breakpoint-up(sm) {
    width: 45.5%;
  }

  @include media-breakpoint-up(lg) {
    width: 30.5%;
  }
}

.project-image{
  overflow: hidden;
  transition-timing-function: ease-in-out;
  transition: 0.2s ease-in-out;
}

.project-image:hover{
  transition: 0.4s cubic-bezier(0.25, 0.1, 0.26, 1.82);
  transform: scale(1.3) rotate(10deg);

}

.title{
  color: black;
  font-family: Helvetica;
  font-size: 1.2rem;
  line-height: 1.15;
}

.title:hover{
  color: #404040;
  text-decoration: underline;
}

.subtitle{
  color: #707070;
  font-size: 0.8rem;
  line-height: 1.15;
}


a:hover{
  text-decoration: none;
}

</style>